import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { RoutingProfileAction } from '@cbridge-packages/routing-profile';
import { detailsSidebarResourceIdSelector } from '@cbridge-packages/details-sidebar';
import { RouterAction, withSkipUnsavedChangesConfirmation } from '@cbridge-packages/routing';
import { generateRoutingProfileRoute } from '@cbridge-packages/routing-client-admin';

type IState = IGetSelectorStateType<typeof detailsSidebarResourceIdSelector>;

export const closeRoutingProfileBeforeRemoveEpic: IEpic<IState> = (action$, state$) => action$.pipe(
  isTypeOfAndGetPayload(RoutingProfileAction.remove.started),
  withLatestFrom(state$),
  mergeMap(([payload, state]) => {
    const { routingProfileId } = payload;
    const openedDetailsId = detailsSidebarResourceIdSelector(state);

    if (routingProfileId === openedDetailsId) {
      return [
        RouterAction.replace([generateRoutingProfileRoute(), withSkipUnsavedChangesConfirmation()]),
      ];
    }

    return [];
  }),
);
